<template>
    <v-card>
        <v-card-title>
        <span class="headline">Log In</span>
        </v-card-title>
        <v-card-text>
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="email" label="Email*" required></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field v-model="password" label="Password*" type="password" required></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <small @click="$store.commit('OPEN_POPUP', 'Restore')">Forgot password?</small>
            <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="$store.commit('OPEN_POPUP', 'Start')" text>Back</v-btn>
            <v-btn color="blue darken-1" @click="clear" text>Clear</v-btn>
            <v-btn color="blue darken-1" @click="login" text>Submit</v-btn>
        </v-card-actions>       
    </v-card>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import helperMixin from '../../helpers/mixin'

    export default {
        name: 'Login',
        mixins: [helperMixin],
        data: function () {
            return {
                email: '',
                password: '',
                alert: false,
                alertValue: ""
            }
        },
        computed:{
            ...mapGetters(['themes'])
        },
        methods:{
            clear(){
                this.email = ''
                this.password = ''
                this.alert = false
            },
            async login(){
                try{
                    const res = await this.logIn({email: this.email, password: this.password})
                    this.$router.push('/')
                    res && this.CLOSE_POPUP()
                    await this.getProfile()
                    await this.getThemes({current: true}) 
                    this.loginRedirects()                                        
                }catch(e){
                    this.SET_ERROR('Login failed: ' + e)
                }
            },
            ...mapActions([
                'logIn',
                'getThemes',
                'getProfile'
            ]),
            ...mapMutations(['CLOSE_POPUP', 'SET_ERROR'])
        }
    }
</script>

<style lang="scss" scoped>

</style>